var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "over-all-usage" }, [
    _c("div", { staticClass: "flex-between" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c("div", [_vm._v("整体提醒名单关爱率")]),
          _c(
            "div",
            {
              staticClass: "flex-align-center",
              staticStyle: { margin: "10px 0" },
            },
            [
              _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.dataSource.dealRate) + "%"),
              ]),
              _c("span", { staticStyle: { margin: "0 10px", color: "#ccc" } }, [
                _vm._v("(日标≥85%)"),
              ]),
              _c("span", [
                _c(
                  "span",
                  { staticStyle: { color: "#333", "font-weight": "600" } },
                  [_vm._v("较上月")]
                ),
                _c("span", { staticClass: "symbol" }, [
                  _vm._v(_vm._s(_vm.dataSource.dealRateDiff >= 0 ? "↑" : "↓")),
                ]),
                _c("span", { staticStyle: { color: "#51abf5" } }, [
                  _vm._v(
                    _vm._s(Math.abs(_vm.dataSource.dealRateDiff || 0)) + "%"
                  ),
                ]),
              ]),
            ]
          ),
          _c("a-progress", {
            attrs: {
              percent: Number(_vm.dataSource.dealRate),
              showInfo: false,
              strokeColor: "#1EAED2",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "card" },
        [
          _c("div", [_vm._v("处理记录认真率")]),
          _c(
            "div",
            {
              staticClass: "flex-align-center",
              staticStyle: { margin: "10px 0" },
            },
            [
              _c(
                "span",
                { staticClass: "num", staticStyle: { color: "#fc7319" } },
                [_vm._v(_vm._s(_vm.dataSource.excellentDealRate) + "%")]
              ),
              _c("span", { staticStyle: { margin: "0 10px", color: "#ccc" } }, [
                _vm._v("(日标≥70%)"),
              ]),
              _c("span", [
                _c(
                  "span",
                  { staticStyle: { color: "#333", "font-weight": "600" } },
                  [_vm._v("较上月")]
                ),
                _c("span", { staticClass: "symbol" }, [
                  _vm._v(
                    _vm._s(
                      _vm.dataSource.excellentDealRateDiff >= 0 ? "↑" : "↓"
                    )
                  ),
                ]),
                _c("span", { staticStyle: { color: "#51abf5" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        Math.abs(_vm.dataSource.excellentDealRateDiff || 0)
                      ) +
                      "%\n          "
                  ),
                ]),
              ]),
            ]
          ),
          _c("a-progress", {
            attrs: {
              percent: Number(_vm.dataSource.excellentDealRate),
              showInfo: false,
              strokeColor: "#FC7319",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "tip", staticStyle: { margin: "12px 0 5px" } },
      [
        _c("span", [
          _c("img", {
            staticStyle: {
              width: "14px",
              height: "14px",
              "margin-right": "5px",
            },
            attrs: {
              src: require("@/assets/imgs/school/monthRecord/warningMark.png"),
              alt: "",
            },
          }),
          _vm._v(
            "\n      整体提醒名单关爱率达标，但处理记录认真率偏低，建议组织优秀班主任分享经验，开展专项培训，提升处理记录的规范性和详实度。\n    "
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }